module.exports = "../../static/img/noDataImg.ec8a102.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/noDataImg.png
// module id = MMRB
// module chunks = 35